import { useDispatch, useSelector } from 'react-redux'

import { selectLoggedinUserName } from '../../../../accessors/index'
import { changeChatOwnership } from '../../../../actions/messaging'
import ChatLockedBar from '../ChatLockedBar/index'

const ChatOwnerBar = ({ ownedBy, chatId, messagingType }) => {
  const dispatch = useDispatch()

  const loggedInUserName = useSelector(selectLoggedinUserName)

  if (!ownedBy || ownedBy === loggedInUserName) {
    return null
  }

  return (
    <ChatLockedBar>
      This chat is owned by {ownedBy}
      <button onClick={() => dispatch(changeChatOwnership(chatId, messagingType))}>
        Take over
      </button>
    </ChatLockedBar>
  )
}

export default ChatOwnerBar
